module.exports = __webpack_public_path__ + "img/arrow-left-12.d3f1c6dd.svg";